import React from 'react'

const Button = React.memo(({ children, value, openModal }) => {
    return (
        <button
            className='max-w-fit bg-primary hover:bg-primary/90 border border-primary text-white px-3 py-1 rounded-sm flex items-center gap-1 font-light'
            onClick={openModal}
        >
            {children}
            {value}
        </button>
    )
});

export default Button